module.exports = __webpack_public_path__ + "img/D1F7.d8e7ef62.jpg";